import axios from 'axios'

export default {
    namespaced: true,
    state: {
        payments: [],
        items: null,
        headers: null,
        loading: false
    },
    getters: {
        items(state) {
            return state.items
        },
        headers(state) {
            return state.headers
        },
        isLoading(state) {
            return Boolean(state.loading)
        }
    },
    mutations: {
        SET_REPORTS_ITEMS(state, value) {
            state.items = value
        },
        SET_REPORTS_HEADERS(state, value) {
            state.headers = value
        },
        SET_LOADING(state, value) {
            state.loading = Boolean(value)
        }
    },
    actions: {
        async getReports({commit}) {
            commit('SET_LOADING', true)
            await axios.get('api/reports')
                .then(({data}) => {
                    commit('SET_REPORTS_ITEMS', data.items)
                    commit('SET_REPORTS_HEADERS', data.headers)
                    commit('SET_LOADING', false)
                })
                .catch(error=>{
                    //console.log(error.message)
                })
        },
        add_report({dispatch}, payload) {
            return axios.post('api/reports', payload)
                .then(() => {
                    dispatch('getReports')
                })
        },
        remove_report({commit, dispatch}, id) {
            commit('SET_LOADING', true)
            return axios.delete('api/reports/' + id)
                .then(() => {
                    dispatch('getReports')
                })
        },
        update_report({commit, dispatch}, payload) {
            commit('SET_LOADING', true)
            return axios.put('api/reports/' + payload.id, payload)
                .then(() => {
                    dispatch('getReports')
                })
        },
        export_to_xlsx({commit}) {
            commit('SET_LOADING', true)
            return axios.get('api/reports/export', {responseType: 'blob'})
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'erkc_report_payments.xlsx') //or any other extension
                    document.body.appendChild(link)
                    link.click()
                }).finally(() => {
                    commit('SET_LOADING', false)
                })
        }
    }
}
